//

import axiosInstance from "shared/axios";
import { queryparamBuilder } from "shared/utils";

const DEPOSIT_URI = {
  depositListing: "/api/v1/deposits/list",
  details: "/api/v1/deposits",
  cashpaymentList: "/api/v1/payments/cash-list",
  createDeposit: "/api/v1/deposits/create",
  operatingBank: "/api/v1/operating-bank-accounts",
};

export const depositListing = (selected, search, params) => {
  let uri = DEPOSIT_URI.depositListing;
  if (selected) {
    uri += `?${selected}=${search}&`;
  } else if (Object.keys(params).length) {
    uri += "?";
  }
  uri += queryparamBuilder(params);
  return axiosInstance.get(`${uri}`);
};
export const cashpaymentList = (subuser_reference_number) => {
  return axiosInstance.get(
    `${DEPOSIT_URI.cashpaymentList}?collected_by_subuser_reference_number=${subuser_reference_number}&is_bank_deposited=no`
  );
};
export const depositDetails = (ref_no) => {
  return axiosInstance.get(`${DEPOSIT_URI.details}/${ref_no}`);
};
export const verifyDeposit = (ref_no, data) => {
  return axiosInstance.post(`${DEPOSIT_URI.details}/${ref_no}/verify-deposit`, {
    _method: "patch",
    ...data,
  });
};
export const cancelDeposit = (ref_no) => {
  return axiosInstance.post(`${DEPOSIT_URI.details}/${ref_no}/cancel-deposit`, {
    _method: "patch",
  });
};
export const createDeposit = (data) => {
  return axiosInstance.post(`${DEPOSIT_URI.createDeposit}`, data);
};
export const fetchOperatingBank = () => {
  return axiosInstance.get(`${DEPOSIT_URI.operatingBank}`);
};
export const depositPaymentList = (ref_no) => {
  return axiosInstance.get(`${DEPOSIT_URI.details}/${ref_no}/payment-list`);
};
export const removeDepositPayment = (ref_no, payments_ref_no) => {
  return axiosInstance.post(`${DEPOSIT_URI.details}/${ref_no}/remove-payment`, {
    payment_reference_number: payments_ref_no,
  });
};
export const addDepositPayment = (param, deposit_ref) => {
  return axiosInstance.post(
    `${DEPOSIT_URI.details}/${deposit_ref}/add-payment`,
    param
  );
};
export const uploadDepositSlip = (ref_no, formData) => {
  return axiosInstance.post(
    `${DEPOSIT_URI.details}/${ref_no}/upload-slip`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
